<template>
	<v-container fluid>
		<v-row no-gutters>
			<v-col cols="12" sm="12" md="4" lg="4" xl="4">
				<v-toolbar-title class="ml-2 mt-2">Planogramas categoria</v-toolbar-title>
			</v-col>
			<v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
				<v-btn class="ml-2 my-1" color="primary" @click="exportar()">
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar
				</v-btn>

				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="abrirImportar()"
				>
					<v-icon left>mdi-upload</v-icon> Importar
				</v-btn>
			</v-col>
		</v-row>
		<v-card class="mt-2 py-4 px-2" elevation="1">
			<v-row no-gutters class="mb-2">
				<v-col cols="12" sm="12" md="4" lg="4" xl="4">
					<v-text-field
						v-model="busca"
						append-icon="mdi-magnify"
						label="Pesquisar"
						dense
						outlined
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="8" lg="8" xl="8" >
					<v-form ref="formFiltro" class="formulario-header">
						<v-autocomplete
							label="Categoria"
							:items="lista.categorias"
							v-model="filtro.categoria"
							multiple
							outlined
							dense
							class="input-cinza"
							:menu-props="menuProps"
							clearable
					>
							<template v-slot:selection="{ item, index }">
									<div
											v-if="
													filtro.categoria.length === 1 && index === 0
											"
											class="autocomplete-selecao"
									>
											{{ item.text }}
									</div>
									<span
											v-if="filtro.categoria.length > 1 && index === 0"
											class="grey--text caption mr-1"
											>{{ filtro.categoria.length }} selecionados</span
									>
							</template>
						</v-autocomplete>

						<v-autocomplete
							label="Filial"
							:items="lista.filiais"
							v-model="filtro.id_java"
							multiple
							outlined
							dense
							class="input-cinza"
							:menu-props="menuProps"
							clearable
					>
							<template v-slot:selection="{ item, index }">
									<div
											v-if="
													filtro.id_java.length === 1 && index === 0
											"
											class="autocomplete-selecao"
									>
											{{ item.text }}
									</div>
									<span
											v-if="filtro.id_java.length > 1 && index === 0"
											class="grey--text caption mr-1"
											>{{ filtro.id_java.length }} selecionados</span
									>
							</template>
						</v-autocomplete>
					</v-form>
				</v-col>
			</v-row>
			<v-data-table
				:headers="headers"
				:items="dadosFiltrados"
				:items-per-page="5"
				:search="busca"
				:server-items-length="total"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 25, 50, 100],
					 itemsPerPageText: 'Linhas por páginas',
						ofText: 'de',
						pageText: '{0}-{1} de {2}',
				}"
				:options.sync="pagination"
				multi-sort
				class="elevation-0"
			>
			<template v-slot:[`item.botao`]="{ item }">
				<v-tooltip 
					left
					nudge-left="-6"
					transition="slide-x-reverse-transition"
					v-if="isDisabledDownload(item)"
					>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							small
							class="mr-2"
							color="grey"
							v-bind="attrs"
							v-on="on"
						>
							mdi-download
						</v-icon>
					</template>
					<span>{{ textTooltipDownload(item) }}</span>
				</v-tooltip>

				<v-icon
					v-else
					small
					class="mr-2"
					color="primary"
					@click="baixar(item)"
				>
					mdi-download
				</v-icon>
			</template>
			</v-data-table>
		</v-card>

		<v-dialog v-model="dialogoImportar" width="90%">
			<v-card>
				<v-toolbar
						elevation="0"
						dark
						class="primary-degrade white--text fix-flex"
				>
						<v-toolbar-title>Importar Planogramas</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn
								fab
								width="24px"
								height="24px"
								elevation="0"
								light
								@click="dialogoImportar = false"
						>
								<v-icon size="18px" color="primary">mdi-close</v-icon>
						</v-btn>
				</v-toolbar>
				<v-card-text>
					<v-alert
						class="ma-1"
						text
						type="info"
						border="left"
						style="font-size: 12px;"
					>
						<ul>
							<li>
								Os arquivos devem estar compactados em uma pasta ZIP.
							</li>
							<li>
								O limite de tamanho do arquivo ZIP é de 200MB.
							</li>
							<li>
								Os arquivos devem estar no formato PDF e nomeados com o seguinte padrão:
								"CATEGORIA_BANDEIRA_CLUSTER_TAMANHO.pdf".
							</li>
							<li>
								O download do arquivo ficará disponível após todo o processo de importação ser concluído.
							</li>
						</ul>
					</v-alert>
					<v-row>
						<v-col cols="8" class="px-2">
							<v-form ref="form" v-model="isPdf">
							

							<v-file-input
								label="Anexar arquivos"
								outlined
								dense
								v-model="arquivosPDF"
								accept=".zip,application/zip"
								:rules="regra.zip"
								multiple
							></v-file-input>
							</v-form>
						</v-col>
						<v-col cols="4" class="px-2">
							<v-row>	<v-col cols="12"></v-col></v-row>
							<v-row>

								
							</v-row>
						</v-col>
					</v-row>
					<v-expand-transition>
						<div v-show="erro">
							<v-row no-gutters class="mb-0">
								<v-col cols="6">
									<download-csv
										:data="erros"
										:labels="errosLabels"
										name="erros.csv"
										delimiter=";"
									>
										<v-btn color="primary">
											<v-icon left
												>mdi-microsoft-excel</v-icon
											>
											Exportar Erros
										</v-btn>
									</download-csv>
								</v-col>
							</v-row>
							<v-data-table
								:headers="headerErros"
								:items="erros"
								:items-per-page="5"
								:options.sync="paginationErros"
								class="elevation-0 tabela"
							></v-data-table>
						</div>
					</v-expand-transition>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						:disabled="!isPdf "
						@click="importar()"
						>
						<v-icon left>mdi-upload</v-icon>
						Importar Arquivos
					</v-btn>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogoImportar = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
				
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			persistent
			content-class="br-15"
			v-model="dialogoProgresso"
			width="600"
			style="z-index: 5000"
		>
			<v-card>
				<v-toolbar
					elevation="0"
					dark
					class="primary-degrade white--text fix-flex"
				>
					<v-toolbar-title>Progresso da importação</v-toolbar-title>
				</v-toolbar>
				<v-card-text class="pa-5">
					<p class="text-center">{{ mensagemProcessamento }}</p>
					<v-progress-linear
						class="mb-3"
						color="teal"
						:value="porcentagem"
						:indeterminate="!enviandoArquivo"
					></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-overlay :value="carregando" :z-index="300">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar
			v-model="alerta"
			:color="alertaColor"
			:timeout="alertaTimeout"
			top
			style="z-index: 400"
		>
			<v-alert :type="alertaColor">
				{{ alertaTexto }}
			</v-alert>
			<v-btn dark text class="float-right" @click="alerta = false">
				Fechar
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import useFiltros from "../../hooks/useFiltros";
const TYPES_FILES = ['.pdf'];
/// Mesmo limite validado no backend (validarZip). Conferir aqui evita que o
/// usuario suba o arquivo inteiro so para receber a recusa no final.
const LIMITE_ZIP_MB = 200;
const LIMITE_ZIP_BYTES = LIMITE_ZIP_MB * 1024 * 1024;

export default {
	 setup() {
    const {
      isLoading,
      isError,
      isFetching,
      lista,
      error,
      refetch,
    } = useFiltros("/planogramasCategoria/filtros");

    return { isLoading, isError, isFetching, lista, error, refetch };
  },
	data() {
		return {
			headers: [
				{ text: "ID JAVA", value: "id_java", align: "center" },
				{ text: "Filial", value: "filial", align: "center" },
				{ text: "Categoria", value: "categoria", align: "center" },
				{ text: "Cluster", value: "nome_cluster", align: "center" },
				{ text: "Tamanho", value: "tamanho", align: "center" },
				{ text: "Bandeira", value: "nome_bandeira", align: "center" },
				{ text: "Criado em", value: "data_criacao", align: "center" },
				{ text: "Usuário", value: "usuario", align: "center" },
				{ text: '', value: 'botao', align: 'center', sortable: false },

			],
			dados: [],
			filtro: {
				id_java: [],
				categoria: [],
				busca: ''
			},
			mes: null,
			mes_importacao: null,
			pagination: {},
			paginationErros: {},
			total: null,
			carregando: false,
			busca: null,
			dialogo: false,
			dialogoImportar: false,
			validaForm: false,
			alerta: false,
			alertaTexto: "",
			alertaColor: "error",
			alertaTimeout: 3000,
			categoriaImport: null,
			filialImport: null,
			arquivosPDF: [],
			/// Progresso do envio, no mesmo padrao do dialogo de exportacao do
			/// extrato. O upload domina o tempo total (numa medicao em HML, 16s de
			/// envio contra 4,5s de processamento), entao sem isto a tela fica
			/// parada a maior parte do tempo.
			dialogoProgresso: false,
			porcentagem: 0,
			mensagemProcessamento: "",
			enviandoArquivo: false,
			regra: {
				pdf: [
					(v) => !!v || "Selecione um arquivo.",
					(v) =>
						(!!v && v.name.toLowerCase().endsWith(".pdf")) ||
						"O arquivo deve ser do tipo PDF",
				],
				zip: [
					(v) =>
						!v ||
						!v.length ||
						!v.some((arquivo) => arquivo.size > LIMITE_ZIP_BYTES) ||
						`O arquivo ZIP excede o limite de ${LIMITE_ZIP_MB}MB.`,
				],
			},
			isPdf: false,
			headerErros: [
				{ text: "Arquivo", value: "arquivo", align: "left" },
				{ text: "Descrição do Erro", value: "msg", align: "left" },
			],
			erros: [],
			errosLabels: { msg: "Descrição do Erro" },
			erro: false,
			options: {
				locale: "pt-BR",
				prefix: "R$",
				suffix: "",
				length: 11,
				precision: 2,
			},
		};
	},
	watch: {
		pagination: {
			handler() {
				this.filtrar();
			},
			deep: true,
		},
	},
	async created() {
		this.mes = this.mesProximo;
		this.mes_importacao = this.mesProximo;
	},
	computed: {
		mesProximo() {
			return this.$moment()
				.add(1, "months")
				.format("YYYY-MM");
		},
		dadosFiltrados() {
			if (this.filtro.id_java.length > 0) {
					return this.dados.filter((item) => {
							return this.filtro.id_java.includes(item.id_java)
					})
			}
			if (this.filtro.categoria.length > 0) {
					return this.dados.filter((item) => {
							return this.filtro.categoria.includes(item.categoria)
					})
			}
			return this.dados
		},
	},
	methods: {
		async filtrar() {
			if (!this.$refs.formFiltro.validate()) return;

			this.carregando = true;
			const data = {};
			data.pagination = this.pagination;
			data.busca = this.busca;
			data.id_java = this.filtro.id_java;

			var response = await this.$http().post("/planogramasCategoria/lista", {
				data: data,
			});

			this.dados = response.data;
			this.total = response.data.length ? response.data[0].total : 0;

			if (this.total == 0 && this.pagination.page > 1) {
				this.pagination.page = 1;
				this.filtrar();
			}

			this.carregando = false;
		},
		async exportar(rotaApi = "exportar") {
			if (!this.$refs.formFiltro.validate()) return;

			this.carregando = true;

			const data = {
				exportar: true,
				categorias: this.filtro.categoria,
				filiais: this.filtro.id_java,
			}

			var response = await this.$http().post("/planogramasCategoria/" + rotaApi, {
				data: data,
			});

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		abrirImportar() {
			if (!this.$refs.formFiltro.validate()) return;

			this.arquivosPDF = null;
			this.erro = false;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			this.mes_importacao =
				this.mes < this.mesProximo ? this.mesProximo : this.mes;
			this.dialogoImportar = true;
		},
		async importar() {
			/// Barra antes de enviar: sem isto o arquivo sobe inteiro e so e
			/// recusado no servidor, depois de todo o tempo de upload.
			const excedentes = Array.from(this.arquivosPDF || []).filter(
				(arquivo) => arquivo.size > LIMITE_ZIP_BYTES
			);

			if (excedentes.length > 0) {
				this.erros = excedentes.map((arquivo) => ({
					arquivo: arquivo.name,
					msg: `O arquivo tem ${(arquivo.size / 1024 / 1024).toFixed(
						1
					)}MB e excede o limite de ${LIMITE_ZIP_MB}MB.`,
				}));
				this.erro = true;
				return;
			}

			this.enviandoArquivo = true;
			this.porcentagem = 0;
			this.mensagemProcessamento = "Enviando arquivo...";
			this.dialogoProgresso = true;

			// var data = { mes: this.mes_importacao + "-01" };

			const formData = new FormData();
			console.log('this.arquivosPDF', this.arquivosPDF.length);
			for (let i = 0; i < this.arquivosPDF.length; i++) {
				formData.append('files', this.arquivosPDF[i]); // NÃO JSON.stringify!
			}
			// formData.append("data", JSON.stringify(data));

			if (this.categoriaImport) {
				formData.append("categoria_nome", this.categoriaImport);
			}
			if (this.filialImport) {
				formData.append("id_java", this.filialImport);
			}
			const response = await this.$http().post(
				"/planogramasCategoria/importar",
				formData,
				{
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: (progressEvent) => {
            if (!progressEvent.total) return;

            this.porcentagem = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );

            const enviadoMB = progressEvent.loaded / 1024 / 1024;
            const totalMB = progressEvent.total / 1024 / 1024;
            this.mensagemProcessamento = `Enviando arquivo... ${enviadoMB.toFixed(
              1
            )}MB de ${totalMB.toFixed(1)}MB`;

            /// Terminado o envio ainda resta o processamento no servidor, que
            /// nao tem como ser medido daqui -- o endpoint so responde no fim.
            /// A barra vira indeterminada para nao ficar parada em 100%
            /// parecendo travada.
            if (this.porcentagem >= 100) {
              this.enviandoArquivo = false;
              this.mensagemProcessamento =
                "Processando os arquivos no servidor. Isso pode levar alguns instantes...";
            }
          },
        });

			/// Fecha antes de tocar em response.data: se a resposta vier malformada,
			/// o acesso abaixo lanca e o dialogo persistente ficaria preso na tela.
			/// O resultado (inclusive os erros por arquivo) e mostrado pela tabela
			/// de erros que a tela ja tem.
			this.enviandoArquivo = false;
			this.dialogoProgresso = false;

			// this.arquivosPDF = null;
			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();

				if (response.data.erros && response.data.erros.length > 0 ){
					this.erros = response.data.erros;
					this.erro = true;
					
					return
				}
				
				this.dialogoImportar = false;
			} else {
				this.filtrar();
				this.erros = response.data.erros;
				this.pagination.page = 1;
				this.erro = true;

				if (response.data.msg) {
					this.alertaTexto = response.data.msg;
					this.alertaColor = "error";
					this.alerta = true;
				}
			}
		},
		isDisabledDownload(item) {
			return item.arquivourl === '' || item.arquivourl === null || item.arquivourl === undefined;  
		},
 		textTooltipDownload(item) {
			return 'O arquivo ainda não foi gerado. Tente novamente mais tarde.';
		},
		baixar(item) {
			if (item.arquivourl === ''){
				this.alertaTexto = "O arquivo ainda não foi gerado. Tente novamente mais tarde.";
				this.alertaColor = "warning";
				this.alerta = true;
				return;
			}
			window.open(this.$arquivoProtegido(item.arquivourl), '_blank')
    }
	},
};
</script>

<style scoped>
.formulario-header {
	display: flex;
	gap: 10px;
	padding: 0px 10px;

	@media (max-width: 960px) {
		flex-direction: column;
		gap: 0px;
		padding: 16px 0 0px;
	}
}
</style>